module.exports = __webpack_public_path__ + "2fa2844b447b25d9fe08ddd412904bf4.png";